import {
  Component,
  HostListener,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  Archive,
  ArchiveCategory,
  Artist,
  FilterItem,
  FilterQuery,
  Show,
} from "../../../services/archive.model";
import { ArchiveService } from "../../../services/archive.service";
import { PlayerService } from "../../core/services/player/player.service";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-archive-list",
  templateUrl: "./archive-list.component.html",
  styleUrls: ["./archive-list.component.scss"],
})
export class ArchiveListComponent {
  @Input() archive: Archive;
  @ViewChild("scrollContainer") scrollContainer: ElementRef;

  public loading = false;
  public activeShowId: number = null;
  public isPlaying = false;
  public playingShowId: number = null;
  public innerWidth: number = window.innerWidth;
  private filter: FilterQuery;

  public playerEnabled = !(
    window.location.hostname === environment.iOSAppDomain
  );

  constructor(
    private archiveService: ArchiveService,
    private playerService: PlayerService,
  ) {
    this.playerService.isPlaying.subscribe(
      (isPlaying) => (this.isPlaying = isPlaying),
    );
    this.archiveService.isLoading.subscribe(
      (loading) => (this.loading = loading),
    );
    this.archiveService.activeFilter.subscribe((filter) => {
      this.filter = filter;
    });
  }

  public getArtwork(path: string) {
    return "url('" + path + "')";
  }

  loadMoreData(): void {
    if (window.innerWidth > 900 && !this.loading) {
      this.archiveService.loadNextPage();
    }
  }

  play(show: Show): void {
    if (!this.isPlaying || this.playingShowId !== show.id) {
      if (this.playingShowId === show.id) {
        this.playerService.play();
      } else {
        this.playingShowId = show.id;
        this.playerService.playFromArchive(show);
      }
    } else {
      this.playingShowId = null;
      this.playerService.pause();
    }
  }

  setActiveShow(id: number) {
    this.activeShowId = id;
  }

  isActiveCat(cat: ArchiveCategory) {
    if (this.filter === undefined) {
      return false;
    }

    if (this.filter[cat.type] === undefined || this.filter[cat.type] === null) {
      return false;
    }

    if (!!this.filter[cat.type].id) {
      return this.filter[cat.type].id === cat.id;
    }

    return false;
  }

  @HostListener("window:scroll", ["$event"])
  onMobileScroll($event) {
    if (window.innerWidth <= 900 && !this.loading) {
      const el = $event.target.documentElement;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 100) {
        this.archiveService.loadNextPage();
      }
    }
  }

  onDesktopScroll($event) {
    if (!this.loading) {
      const el = $event.target;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 100) {
        this.archiveService.loadNextPage();
      }
    }
  }

  showInfoInApp(show: Show) {
    if (!this.playerEnabled) {
      this.playingShowId = show.id;
      this.playerService.playFromArchive(show);
      this.playerService.pause();
      this.playerService.toggleInfo();
    } else {
      this.play(show);
    }
  }

  toggleCategoryFilter(cat: ArchiveCategory) {
    // Create a new filter query based on the current one
    const newFilter: FilterQuery = {
      mood: this.filter.mood,
      flavor: this.filter.flavor,
      location: this.filter.location,
    };

    // Toggle the clicked category
    if (this.isActiveCat(cat)) {
      // If active, remove it
      newFilter[cat.type] = null;
    } else {
      // If not active, add it
      const filterItem: FilterItem = {
        id: cat.id,
        name: cat.name,
      };
      newFilter[cat.type] = filterItem;
    }

    // Update the filter
    this.archiveService.search(newFilter);
  }

  getTotalCategoryChars(categories: ArchiveCategory[]): number {
    if (!categories || categories.length === 0) {
      return 0;
    }
    return categories.reduce(
      (total, cat) => total + (cat.name ? cat.name.length : 0),
      0,
    );
  }

  isLongCategories(categories: ArchiveCategory[]): boolean {
    return (
      categories.length > 9 || this.getTotalCategoryChars(categories) >= 75
    );
  }
}
